module.exports = __webpack_public_path__ + "static/media/ic_search.f9762ab9.svg";